import { AbstractControl, ValidationErrors } from '@angular/forms';

export class SpecialCharValidators {
    static specialCharValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        const value: string = control.value;

        if (!value) return null;

        // Check for leading space
        if (/^\s/.test(value)) {
            return { startsWithSpecial: true };
        }

        // Check for trailing space
        if (/\s$/.test(value)) {
            return { endsWithSpecial: true };
        }

        // Check for consecutive spaces
        if (/\s{2,}/.test(value)) {
            return { consecutiveSpecials: true };
        }

        // Basic pattern to allow letters and allowed characters ' . , and space
        const basicPattern = /^[a-zA-Z-'.,]+(?: [a-zA-Z-'.,]+)*$/;
        if (!basicPattern.test(value)) {
            return { invalidCharacters: true };
        }

        // Disallow consecutive special characters
        const consecutiveSpecials = /[-',.]{2,}/;
        if (consecutiveSpecials.test(value)) {
            return { consecutiveSpecials: true };
        }

        // Disallow starting with ., -, ', or ,
        const startsWithInvalid = /^[.,'-]/;
        if (startsWithInvalid.test(value)) {
            return { startsWithSpecial: true };
        }

        // Disallow ending with -, ', or ,
        const endsWithInvalid = /[-',]$/;
        if (endsWithInvalid.test(value)) {
            return { endsWithSpecial: true };
        }

        return null;
    }
}
